export const tabsScrollCenter = (tabToScroll) => {
    const statsHistoryTabActive = document.querySelector(tabToScroll);

    if (statsHistoryTabActive) {
        statsHistoryTabActive.scrollIntoView({
            inline: 'center',
            block: 'nearest',
            behavior: 'smooth'
        });
    }
}
